import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

/**
 * Custom hook to calculate and set notes count from notes object.
 * @param {object} notes - Notes object containing reportReplenishmentNotes and reportUsageNotes.
 * @param {function} setNotesCount - State setter for notes count.
 */
export function useNotesCount({ notes, setNotesCount }) {
    useEffectWithErrorLogging(() => {
        if (notes) {
            const notesAr = [
                ...(notes?.reportReplenishmentNotes || []),
                ...(notes?.reportUsageNotes || []),
            ];
            const count = notesAr.filter((it) => it.isNew === true).length;
            setNotesCount(count);
        }
    }, [notes]);
}
